import { useSyncExternalStore } from 'react';

import {
  getMaintenanceMode,
  subscribeToMaintenanceMode,
} from '@/api/httpClient';

/**
 * True once the BFF has answered a request with a 503, meaning the platform is
 * in maintenance mode. Latches until the page is reloaded.
 */
export const useMaintenanceMode = (): boolean =>
  useSyncExternalStore(
    subscribeToMaintenanceMode,
    getMaintenanceMode,
    getMaintenanceMode
  );
